import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { noAuthGuard } from './core/guard/no-auth.guard';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { authGuard } from './core/guard/auth.guard';
import { routeMetaData } from './shared/constants/route-metadata.constant';

const routes: Routes = [
  {
    path: '',
    redirectTo: routeMetaData.myAccount.link.startsWith('/')
      ? routeMetaData.myAccount.link.substring(1)
      : routeMetaData.myAccount.link,
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: routeMetaData.myAccount.link.startsWith('/')
          ? routeMetaData.myAccount.link.substring(1)
          : routeMetaData.myAccount.link,
        pathMatch: 'full',
      },
      {
        path: routeMetaData.myAccount.link.startsWith('/')
          ? routeMetaData.myAccount.link.substring(1)
          : routeMetaData.myAccount.link,
        loadChildren: () =>
          import('./modules/my-account/my-account.module').then(
            (m) => m.MyAccountModule
          ),
      },
      {
        path: routeMetaData.requests.link.startsWith('/')
          ? routeMetaData.requests.link.substring(1)
          : routeMetaData.requests.link,
        loadChildren: () =>
          import('./modules/requests/requests.module').then(
            (m) => m.RequestsModule
          ),
      },
      {
        path: routeMetaData.accessAndUse.link.startsWith('/')
          ? routeMetaData.accessAndUse.link.substring(1)
          : routeMetaData.accessAndUse.link,
        loadChildren: () =>
          import('./modules/api-instruction/api-instruction.module').then(
            (m) => m.ApiInstructionModule
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
